import * as React from "react";
import { Cruise } from "main/javascripts/types/cruise";
import { SaleCruiseCard } from "main/javascripts/components/cruise/SaleCruiseCard";

export interface IProps {
  saleCruises: Cruise.SaleCruise[];
}

export const LpCruiseSaleList: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { saleCruises } = props;

  return (
    <>
      {saleCruises.map((cruise: Cruise.SaleCruise, index) => {
        return <SaleCruiseCard key={index} saleCruise={cruise} />;
      })}
    </>
  );
};
